// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import {
    Divider,
    FormControl,
    TextField,
    Typography,
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import { useToast } from '../../../components/ToastProvider';
import moment from 'moment';
import Swal from 'sweetalert2'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

export default function Index() {
    const { showToast, hideToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const navigate = useNavigate();
    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))
    const [tabs, setTabs] = useState<string>("0")

    const [listData, setListData] = useState<any[]>([])
    useEffect(() => {
        getData()
    }, [tabs])
    const getData = () => {
        setListData([])
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/omni/shopee/list'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    tabs: tabs
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
    }
    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            px: 2,
                            py: 1
                        }}
                    >
                        {/* Title Section */}
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                Shopee
                            </Typography>
                        </Box>

                        {/* Button Section */}
                        <Box>
                            <Button
                                variant="contained"
                                color="warning"
                                startIcon={<Icon icon="mdi:arrow-left" />}
                                onClick={() => navigate(-1)}
                            >
                                Kembali
                            </Button>
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start',mb:3 }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Awal'
                                        type='date'
                                        onChange={(e) => setTglAwal(e.target.value)}
                                        value={tglAwal}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>

                                    <TextField
                                        label='Tanggal Akhir'
                                        type='date'
                                        onChange={(e) => setTglAkhir(e.target.value)}
                                        value={tglAkhir}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={() => getData()}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <TabContext value={tabs}>
                            <TabList
                                scrollButtons
                                variant='fullWidth'
                                onChange={handleChangeTabs}
                            >
                                <Tab
                                    value='0'
                                    label='Transaksi'
                                    icon={<Icon icon='mdi:clipboard-text-outline' />}
                                />

                                <Tab
                                    value='1'
                                    label='Penjualan'
                                    icon={<Icon icon='mdi:cart-check' />}
                                />

                                <Tab
                                    value='2'
                                    label='Retur'
                                    icon={<Icon icon='mdi:backup-restore' />}
                                />
                            </TabList>
                            <TabPanel value='0'>
                                <Grid
                                    item
                                    container
                                    sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end',mb:3 }}
                                    spacing={5}
                                >
                                    <Grid item xs={12} md={2}>
                                        <FormControl fullWidth>
                                            <Button
                                                variant='contained'
                                                color="secondary"
                                                sx={{ mt: 1 }}
                                                startIcon={<Icon icon="mdi:upload" />}
                                                onClick={() => navigate('/omni/shopee/import')}
                                            >
                                                Import
                                            </Button>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <MsiDatagrid array={listData} />
                            </TabPanel>
                            <TabPanel value='1'>
                                <Grid
                                    container
                                    justifyContent='flex-end'
                                    spacing={2}
                                    sx={{ mb: 3 }}
                                >
                                    <Grid item>
                                        <Button
                                            variant='contained'
                                            color='secondary'
                                            startIcon={<Icon icon='mdi:upload' />}
                                            onClick={() => navigate('/omni/shopee/import-penjualan')}
                                        >
                                            Import Penjualan
                                        </Button>
                                    </Grid>
                                </Grid>
                                <MsiDatagrid array={listData} />
                            </TabPanel>
                            <TabPanel value='2'>
                                <Grid
                                    container
                                    justifyContent='flex-end'
                                    spacing={2}
                                    sx={{ mb: 3 }}
                                >
                                    <Grid item>
                                        <Button
                                            variant='contained'
                                            color='secondary'
                                            startIcon={<Icon icon='mdi:upload' />}
                                            onClick={() => navigate('/omni/shopee/import-retur')}
                                        >
                                            Import Retur
                                        </Button>
                                    </Grid>
                                </Grid>
                                <MsiDatagrid array={listData} />
                            </TabPanel>
                        </TabContext>
                    </CardContent>
                </div>
            </Grid>
        </Grid>
    )
}